import { useFirebaseOrdersListeners } from '@/features/orders/hooks/useFirebaseOrdersListeners'
import { FC } from 'react'

const FirebaseOrdersListener: FC = () => {
    useFirebaseOrdersListeners()

    return null
}

export default FirebaseOrdersListener
